var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('comp-table',{attrs:{"title":"商城自提点库存管理","edit-key":"id","columns":_vm.columns,"table-api":"/gateway/apps/o2o/api/terminal/goods/listByTerminalGoods","form-component":_vm.dataForm}})}
var staticRenderFns = []

export { render, staticRenderFns }